import { assetsBaseUrl } from "../constantData"

export const getImageUrl = (name: string, subDirectory?: string) => {
    return `${assetsBaseUrl}${subDirectory ?? ''}${name.includes('.') ? name : name + '.svg'}`;
}